import {usePageChange} from '@/utils/usePageChange'
import {useGSAP}       from '@gsap/react'
import gsap            from 'gsap'
import ScrollTrigger   from 'gsap/ScrollTrigger'
import {useState}      from 'react'

const useFloatingMenuColor = () => {
	const [isFloatingMenuLight, setIsFloatingMenuLight]               = useState(false)
	const [shouldUpdateScrollTriggers, setShouldUpdateScrollTriggers] = useState(true)

	function updateButtonColor(section) {
		const isWhite = section.classList.contains('js-floating-menu-light')
		setIsFloatingMenuLight(isWhite)
	}

	usePageChange(() => setShouldUpdateScrollTriggers(true))

	useGSAP(() => {
		if (!shouldUpdateScrollTriggers) {
			return
		}

		gsap.registerPlugin(ScrollTrigger)

		const sections = document.querySelectorAll('.js-section')

		sections.forEach((section) => {
			ScrollTrigger.create({
				trigger:     section,
				start:       'top 95%', // 95% is the approximated position of the menu on the page
				end:         'bottom 95%',
				markers:     false,
				onEnter:     () => updateButtonColor(section),
				onEnterBack: () => updateButtonColor(section),
			})
		})

		requestAnimationFrame(() => setShouldUpdateScrollTriggers(false))
	}, [shouldUpdateScrollTriggers])

	return {
		isFloatingMenuLight,
	}
}

export default useFloatingMenuColor
